import React, { useEffect, useState } from "react";
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Col, Row } from "reactstrap";
import axios from "axios";

const LinkCandidate = ({ onSelectedCandidatesChange,label,error , jobId  }) => {
    const [jobDetailsVisible, setJobDetailsVisible] = useState(false);
    // const [searchText, setSearchText] = useState('');
    const [candidateSearchText, setCandidateSearchText] = useState('');

    const [selectedJobs, setSelectedJobs] = useState(null);
    const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });
    const [jobs, setJobs] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [selectedJobTitles, setSelectedJobTitles] = useState('');

 const filteredJobs = jobs.filter(job => {
  const q = candidateSearchText.toLowerCase();

  return (
    job?.first_name?.toLowerCase().includes(q) ||
    job?.designation?.toLowerCase().includes(q) ||
    job?.email?.toLowerCase().includes(q) ||
    job?.current_company?.toLowerCase().includes(q) ||
    job?.id?.toString().includes(candidateSearchText)
  );
});


    // const handleSave = () => {
    //     // Display candidate names in the InputText
    //     const selectedCandidateNames = selectedJobs.map((job) => job.first_name).join(', ');
    //     setSelectedJobTitles(selectedCandidateNames);
    //     // Pass selected candidates (including IDs) to parent
    //     // onSelectedCandidatesChange?.(selectedJobs);
    //      onSelectedCandidatesChange?.(selectedJob ? [selectedJob] : []);
    //     setJobDetailsVisible(false);
    // };
         const handleSave = () => {
        const selectedCandidateName = selectedJobs?.first_name || '';
        setSelectedJobTitles(selectedCandidateName);
        onSelectedCandidatesChange?.(selectedJobs ? [selectedJobs] : []);
        setJobDetailsVisible(false);
    };
    const handleRefresh = () => {
        setSelectedJobs(null);
        setSelectedJobTitles('');
        // setSearchText('');
        setCandidateSearchText('');
    };

    const handleIconClick = () => {
        setCandidateSearchText('');
        setJobDetailsVisible(true);
    };

    const onPageChange = (event) => {
        setLazyParams({ page: event.page, rows: event.rows });
    };

    // const getallactivejobs = async () => {
    //     setLoading(true);
    //     try {
    //         const page = lazyParams?.page ?? 0;
    //         const rows = lazyParams?.rows ?? 10;
    //         const response = await axios.get(`/api/v1/candidates/?page=${page + 1}&size=${rows}&status=Active`);
    //         if (response.status === 200) {
    //             const transformedData = response.data.results.map((cond) => ({
    //                 first_name: cond.first_name,
    //                 designation: cond.designation,
    //                 current_company: cond.current_company,
    //                 email: cond.email,
    //                 id: cond.candidate_id
    //             }));
    //             setJobs(transformedData);
    //             setTotalRecords(response.data.count || 0);
    //         } else {
    //             setJobs([]);
    //             setTotalRecords(0);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching candidates:', error);
    //         setJobs([]);
    //         setTotalRecords(0);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // useEffect(() => {
    //     getallactivejobs();
    // }, [lazyParams.page, lazyParams.rows]);
    const userInfos = JSON.parse(sessionStorage.getItem("user-info"));
    const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
    const [companyId, setCompanyId] = useState(intialcompanyId);
const getCandidatesForJob = async () => {
  setLoading(true);
  try {
    const page = lazyParams?.page ?? 0;
    const rows = lazyParams?.rows ?? 10;
    const response = await axios.get(
      `/api/v1/candidate-jobs/?page=${page + 1}&size=${rows}&job_id=${jobId}&company_id=${companyId}`
    );
    if (response.status === 200) {
      const transformedData = response.data.results.map((candidate) => ({
        first_name: candidate.name,
        designation: candidate.designation_name,
        current_company: candidate.current_company_name,
        email: candidate.email,
        id: candidate.candidate_id,
        talent_scan_id:candidate.talent_scan_id
        // talent_scan_id:"608"
      }));
      setJobs(transformedData);
      setTotalRecords(response.data.count || 0);
    } else {
      setJobs([]);
      setTotalRecords(0);
    }
  } catch (error) {
    console.error('Error fetching candidates for job:', error);
    setJobs([]);
    setTotalRecords(0);
  } finally {
    setLoading(false);
  }
};
useEffect(() => {
  // Clear candidate selection when jobId changes
  setSelectedJobs(null);
  setSelectedJobTitles('');
  onSelectedCandidatesChange?.([]);
  if (jobId) {
    getCandidatesForJob();
  }
}, [jobId]);

useEffect(() => {
  if (jobId) {
    getCandidatesForJob();
  }
}, [lazyParams.page, lazyParams.rows]);
const [talentScanResults, setTalentScanResults] = useState([]);
const [showTalentScanModal, setShowTalentScanModal] = useState(false);
const [selectedTalentScanId, setSelectedTalentScanId] = useState(null);
const fetchTalentScanResults = async (talentScanId) => {
    setLoadingTalentScanId(talentScanId);
  try {
    const response = await axios.post(
      `/api/v1/candidate-talent-scan-result/?page=1&size=10&company_id=${companyId}`,
      { talent_scan_id: talentScanId,job_id:jobId }
    );
    if (response.status === 200) {
      setTalentScanResults(response.data.talent_scan_result.results || []);
      setShowTalentScanModal(true);
    }
  } catch (error) {
    console.error("Error fetching talent scan results:", error);
    setTalentScanResults([]);
  }finally{
    setLoadingTalentScanId(null); 
    }
};
// const [isLoadingTalentScan, setIsLoadingTalentScan] = useState(false);
const [loadingTalentScanId, setLoadingTalentScanId] = useState(null);

    return (
        <Col lg={6}>
            <div className="field">
                <label htmlFor="job" className="block mb-0">{label ? label : "Candidates"}</label>
                <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                    <InputText
                        id="job"
                        value={selectedJobTitles}
                        onChange={(e) => setSelectedJobTitles(e.target.value)}
                        placeholder="Select Candidates"
                        className="w-full"
                        style={{ paddingRight: '2rem',cursor: "pointer" }}
                        onClick={handleIconClick}
                        readOnly // Make it read-only to prevent manual edits
                    />
                    
                    <i
                        className="pi pi-chevron-down"
                        onClick={handleIconClick}
                        style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer'
                        }}
                    ></i>
                   
                </div>
                 {error && (
                    <small className="p-error">{error}</small>
                )}
                <Dialog
                    header="Link Candidate"
                    visible={jobDetailsVisible}
                    onHide={() => {
                        setJobDetailsVisible(false)
                        setCandidateSearchText('');
                    }}
                    style={{ width: '60vw' }}
                    breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                    className="cand-details"
                >
                    {/* Search Bar (Uncomment if needed) */}
                    <Row>
                        <Col lg={12}>
                            <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                               <InputText
                                    placeholder="Search Candidates"
                                    value={candidateSearchText}
                                    onChange={(e) => setCandidateSearchText(e.target.value)}
                                    style={{ paddingRight: '2rem' }}
                                    />

                                <i
                                    className="pi pi-search"
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                    }}
                                ></i>
                            </div>
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col sm={12}>
                            <div id="LinkCandidates_DataTableView">
                                {/* DataTable */}
                                <DataTable
                                    value={filteredJobs}
                                    selection={selectedJobs}
                                onSelectionChange={(e) => {
                                    setSelectedJobs(e.value);
                                    onSelectedCandidatesChange?.(e.value ? [e.value] : []);
                                    }}

                                    dataKey="id" // Changed to match transformed data
                                    size="small"
                                    lazy
                                    paginator
                                    first={lazyParams.page * lazyParams.rows}
                                    rows={lazyParams.rows}
                                    totalRecords={totalRecords}
                                    onPage={onPageChange}
                                    id="AllEmployees_TableView"
                                    loading={loading}
                                    scrollable
                                    scrollHeight="500px"
                                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                    rowsPerPageOptions={[10, 20, 50, totalRecords]}
                                >
                                    <Column selectionMode="single" style={{ width: '50px' }} />
                                    <Column field="first_name" header="Candidate Name" body={(rowData) => rowData.first_name || "–"} style={{ width: '120px' }}/>
                                    <Column field="designation" header="Designation" body={(rowData) => rowData.designation || "–"} style={{ width: '120px' }}/>
                                    <Column field="current_company" header="Company" body={(rowData) => rowData.current_company || "–"} style={{ width: '120px' }} />
                                    <Column
                                    header="Talent Scan"
                                    body={(rowData) =>
                                        rowData.talent_scan_id ? (
                                        <button
                                            className="btn btn-sm btn-primary"
                                            onClick={() => {
                                            setSelectedTalentScanId(rowData.talent_scan_id);
                                            fetchTalentScanResults(rowData.talent_scan_id);
                                            }}
                                            disabled={loadingTalentScanId === rowData.talent_scan_id}
                                            style={{ width: "100px"}}
                                        >
                                            {loadingTalentScanId === rowData.talent_scan_id && (
                                            <span
                                                className="pi pi-spinner pi-spin"
                                                style={{ marginRight: '8px' }}
                                            ></span>
                                            )}
                                            View Result
                                        </button>
                                        ) : (
                                        "–"
                                        )
                                    }
                                    />
                                </DataTable>
                            </div>
                        </Col>
                    </Row>

                    {/* Actions */}
                    <div className="d-flex mt-3 justify-content-center">
                        <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSave}>Save</button>
                        <button type="button" className="btn btn-primary btn-main" onClick={handleRefresh}>Refresh</button>
                    </div>
                </Dialog>
               <Dialog
                header="Talent Scan Results"
                visible={showTalentScanModal}
                onHide={() => setShowTalentScanModal(false)}
                style={{ width: "60vw" }}
                breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                >
                {talentScanResults?.length > 0 ? (
                    talentScanResults.map((result, index) => (
                    <div key={index} className="p-3 border rounded mb-3 bg-light">
                        <h5 className="text-primary mb-3">{result?.test_info?.name || "Unnamed Test"}</h5>

                        <Row>
                        <Col md={6}>
                            <h6>🧑 Candidate Info</h6>
                            <p><strong>Name:</strong> {result?.candidate_info?.name}</p>
                            <p><strong>Email:</strong> {result?.candidate_info?.email}</p>
                            <p><strong>Phone:</strong> {result?.candidate_info?.phone}</p>
                            <p><strong>Industry:</strong> {result?.candidate_info?.industry}</p>
                            <p><strong>Experience:</strong> {result?.candidate_info?.experience} yrs</p>
                        </Col>

                        <Col md={6}>
                            <h6>🧾 Test Info</h6>
                            <p><strong>Designation:</strong> {result?.test_info?.test_designation}</p>
                            <p><strong>Skills:</strong> {result?.test_info?.skills?.join(", ")}</p>
                            <p><strong>Attempted:</strong> {result?.is_attempted ? "Yes" : "No"}</p>
                            <p><strong>Link:</strong>{" "}
                            <a href={result?.link} target="_blank" rel="noreferrer">
                                Open Talent Scan
                            </a>
                            </p>
                        </Col>
                        </Row>

                        <h6 className="mt-3">📊 Section Scores</h6>
                        <DataTable value={result?.score_info || []} responsiveLayout="scroll" size="small">
                        <Column field="section__name" header="Section" />
                        <Column field="total_score" header="Total Score" />
                        <Column field="cutoff_score" header="Cutoff" />
                        <Column field="score_secured" header="Score Secured" />
                        <Column field="percentage" header="Percentage" />
                        </DataTable>

                        <h6 className="mt-4">🏁 ATS Summary</h6>
                        <Row>
                        <Col md={4}><strong>Total Score Secured:</strong> {result?.ats_details?.total_score_secured}</Col>
                        <Col md={4}><strong>Actual Total Score:</strong> {result?.ats_details?.actual_total_score}</Col>
                        <Col md={4}><strong>Percentage:</strong> {result?.ats_details?.percentage_score}%</Col>
                        </Row>
                    </div>
                    ))
                ) : (
                    <p>No Talent Scan results found.</p>
                )}
                </Dialog>


            </div>
        </Col>
    );
};

export default LinkCandidate;